var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionRoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19ZM9.49403 28.505C8.90824 27.9192 8.90824 26.9695 9.49403 26.3837L16.8787 18.999L9.49576 11.6161C8.90998 11.0303 8.90998 10.0806 9.49576 9.49479C10.0815 8.909 11.0313 8.909 11.6171 9.49479L19 16.8777L26.3829 9.49479C26.9687 8.909 27.9185 8.909 28.5042 9.49479C29.09 10.0806 29.09 11.0303 28.5042 11.6161L21.1213 18.999L28.506 26.3837C29.0918 26.9695 29.0918 27.9192 28.506 28.505C27.9202 29.0908 26.9704 29.0908 26.3847 28.505L19 21.1203L11.6153 28.505C11.0296 29.0908 10.0798 29.0908 9.49403 28.505Z",
    fill: "#0800A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionRoundIcon);
export default __webpack_public_path__ + "static/media/CautionRoundIcon.59d8cc422db46b06c59d47b69799e8df.svg";
export { ForwardRef as ReactComponent };